module.exports = __webpack_public_path__ + "static/img/google_play_badge_mustard.c6e49ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/google_play_badge_mustard.png
// module id = n8Tw
// module chunks = 1